<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M14.9994 15.1562L9 9.15625M9.00064 15.1562L15 9.15625"
      stroke="currentColor"
      stroke-opacity="0.87"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22 12.1562C22 6.6334 17.5228 2.15625 12 2.15625C6.47715 2.15625 2 6.6334 2 12.1562C2 17.679 6.47715 22.1562 12 22.1562C17.5228 22.1562 22 17.679 22 12.1562Z"
      stroke="currentColor"
      stroke-opacity="0.87"
      stroke-width="1.5"
    />
  </svg>
</template>